import React, { 
  FunctionComponent, useContext, useEffect, useLayoutEffect, useRef, useState 
} from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  DialogActions,
  Link,
  Paper,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  Theme,
  Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { Favorite, FolderSpecial, Share } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';
import { filter, orderBy, union } from 'lodash';
import _ from 'lodash';
import { get, isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

import { PhotoProvider, PhotoSlider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

import { 
  getAllCatalogsAction, getCatlogsAction, getFilterAction, getLanguageAction, usePorducts 
} from '@ivymobi/orbit-core/business/productCenter';
import { getOutCatlogsAction, getRobotProductsDetailAction } from '@ivymobi/orbit-core/business/user';
import { getAccountAction, useAccount, } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction, useStats } from '@ivymobi/orbit-core/business/stats';
import { getFileType, Tenant } from '@ivymobi/orbit-core';
import { createShareAction, userShareEvent } from '@ivymobi/orbit-core/business/share';
import { documentEventAction } from '@ivymobi/orbit-core/business/document';

import { hashMapTree, getBreadcrumbsPath } from './tools/index';
import wx from 'weixin-js-sdk';
import * as viewer from 'h5-imageviewer';
import { DeviceType, UserContext, TenantContext, WebSiteContext, InnerUserContext } from '../orbit-context';
import { Loading, TabPanel } from '../components';
import RichText from '../components/richText/RichTextRenderer';
import ZTree from './components/zTree';
import FavorDialog from '../documents/favor';
import ShareForm from '../documents/share';

// import QuickStart from '../dashboard/quickStart';
// import Title from '../components/views/title';
// import Menus, { OpenMenuItem } from '../components/views/menuItem';
// import RobotSearch from './component/robotSearch';
// import ProductItem from './component/productItem';
// import FilterView from './component/filterView';
// import Loader from '../components/loaders';

import D3DImageView from './components/d3dImageView';
import i18n from '../services/i18n';
import Utills from '@ivymobi/orbit-core/util/utills';
// import { getTitleById } from './mapping';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    "@media (min-width: 768px)": {
      flexDirection:'row',
    }, 
    "@media (max-width: 768px)": {
      flexDirection:'column',
    },
    width: '100%',
    height: '100%'
  },
  sliderBar:{
    display: 'flex',
    flexDirection:'column',
    width:'25%',
    paddingTop:theme.spacing(2),
    paddingBottom:theme.spacing(2)
  },
  mask:{
    backgroundColor:'white',
    background:'white'
  },
  content:{
    flexGrow:1,
    flexBasis:0,
    display:'flex',
    // justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    paddingTop:theme.spacing(2),
    paddingBottom:theme.spacing(2)  
  },
  richbox1: {
    display: 'flex', 
    flexDirection: 'column', 
    height: '100%',
  },
  richbox2: {
    display: 'flex', 
    flexDirection: 'column',
    minHeight: '100%'
  },
  tabbox: {
    height: '48px',
    // position: containerStyle === 'small' ? 'sticky': 'sticky',
    position: 'sticky',
    top: '56px',
    zIndex: '9',
    background: '#fff',
    // borderBottom: containerStyle === 'small' ? '1px solid #ccc': 'none',
  },
  tabboxfixed: {
    height: '48px',
    // position: containerStyle === 'small' ? 'sticky': 'sticky',
    // position: 'sticky',
    // top: '56px',
    // zIndex: '9',
    background: '#fff',
    // borderBottom: containerStyle === 'small' ? '1px solid #ccc': 'none',
  },
  tabitem: {
    paddingTop: '8px',
    paddingBottom: 0,
    fontSize:'16px',
    fontWeight: 'bold',
    opacity: '1',
  },
  overflowBox: {
    padding: theme.spacing(1.5),
    height: '100%',
    overflow: 'hidden',
    overflowY: 'auto',
  },
  featContent1: {
    width: '30%',
    lineHeight: '24px',
    paddingLeft: '12px'
  },
  featContent2: {
    width: '70%',
    lineHeight: '24px',
    paddingLeft: '12px',
    paddingRight: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    lineClamp: 2,
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-word'
  },
  featContent: {
    width: '70%',
    lineHeight: '24px',
    paddingLeft: '12px',
    paddingRight: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-word'
  },
  tv_box: {
    width: '100%',
    height: '100%',
    padding: '10px',
    overflow: 'auto',
    '& .table_header': {
      width: '100%', 
      padding: '8px 15px',
      backgroundColor: '#d9d9d9', 
    }
  },
  fi_public: {
    display: 'flex',
    width: '100%',
    paddingTop: '6px',
    paddingBottom: '6px',
    borderLeft: '1px solid rgb(215, 215, 215)',
    borderBottom: '1px solid rgb(215, 215, 215)',
  },
  mult: {
    paddingLeft: '10px', 
    height: '100%', 
    paddingTop: '10px', 
    paddingRight: '10px', 
    textWrap: 'nowrap', 
    cursor: 'pointer' 
  },
  p10: {
    padding: '10px'
  },
  mt10: {
    marginTop: '10px'
  }
}));

// 解析产品图片
const getImageUrl = (item, defalut) => {
  if (item?.mime && item?.mime.length > 0) {
    let items = filter(item.mime, {mimePurpose: 'detail'});
    if (items.length === 0) {
      items = filter(item.mime, {mimePurpose: 'thumbnail'});
    }
    if (items.length > 0) {
      let img = _.get(items[0], "['mimeSource']");
      return img.length > 0 ? img : defalut;
    }
  }
  return defalut;
}

const queryParse = (query)=>{
  query = query.substring(query.indexOf('?') + 1);
  let array = query.split("&")
  let params = {};
  array.forEach(item => {
    let key = item.substring(0, item.indexOf('='));
    if (key==='')
      return;
    let value= decodeURIComponent(item.substring(item.indexOf('=') + 1));
    params[key]= value;
  });
  return params;
}

export const ProductDetailView = (props: any) => {
  const { id, handleShare, handleFav ,language_info} = props;
  const [ftTechnicals, setFtTechnicals] = useState();

  const dispatch = useDispatch();
  const tenant = useContext(TenantContext);
  const user = useContext(UserContext);
  const history = useHistory();
  const [t] = useTranslation();
  const classes = useStyles();
  const deviceType = useContext(DeviceType);

  const [showData, setShowData] = useState(null)
  const [productDetail, setProductDetail] = useState(null);
  const [extraBreadcrumbs, setExtraBreadcrumbs] = useState([]);

  const [d3dImages, setD3dImages] = useState([]);
  const [dataSheets, setDataSheets] = useState([]);
  const [showImageUrl, setShowImageUrl] = useState({show: false, url: ''});
  const lan = i18n.language === 'zh-CN' ? 'zh' : i18n.language;

  const get3dUrls = (item) => {
    if( item?.mime && (item?.mime.length > 0)) {
      let images =[];
      let items = filter(item.mime, {mimePurpose: 'detail'});
      for (let i = 0; i < items.length; i++) {
        images.push(items[i].mimeSource[0]['#text'])
      }
      setD3dImages(images);
    }
  }

  const getDataSheet = (item) => {
    let infos= [];
    let datasheets =[];
    let selections = [];
    let controls = [];
    if (item?.mime && (item?.mime.length > 0)) {
      let items = filter(item.mime, {mimePurpose: 'data_sheet'});
      for (let i = 0; i < items.length; i++) {
        datasheets.push({url: items[i].mimeSource[0]['#text'], name: items[i].mimeAlt[0]['#text'], type: 'dataSheet', to: items[i].mimeSource[0]['#text']})
      }
    }
    if (item?.productReference.length>0) {
      let accs = filter(item.productReference, {type: 'accessories'});
      accs.map((item) => {
        let thumbnail = filter(item.mime, {mimePurpose: 'thumbnail'});

        selections.push({name:item.details?.descriptionShort?.zh,url:thumbnail[0].mimeSource[0]['#text'],to:'/'+params.catalogType+'/productDetail/'+item.id+'?catalogType='+params.catalogType})
      })
      let contrl = filter(item.productReference, {type: 'others'});
      contrl.map((item) => {
        let thumbnail = filter(item.mime, {mimePurpose: 'thumbnail'});

        controls.push({name:item.details?.descriptionShort?.zh,url:thumbnail[0].mimeSource[0]['#text'],to:'/'+params.catalogType+'/productDetail/'+item.id+'?catalogType='+params.catalogType})
      })
    }
    if (datasheets.length>0) {
      infos.push({data:datasheets, name:t('相关资料')});
    }
    if (controls.length>0) {
      infos.push({data:controls, name:t('控制器')});
    }
    if (selections.length>0) {
      infos.push({data:selections, name:t('选件')});
    }
    // console.log("infos====", infos)
    setDataSheets(infos)
  }
    // formatFeatures  格式化数据时使用的方法
    const getMultiValues = (id, productOptions, lang) => {
      for (let i=0;i<productOptions.length;i++) {
        let reuslt = '';
        const opt = productOptions[i];
        if (opt.fvalue===id) {
          const values = _.get(opt, ['ftValues', 'ftValue'], []);
          for (let m=0; m<values.length; m++) {
            let value = values[m];
            if (value.valueRange) {
              // reuslt.push(_.get(value.valueRange, ['#'], '')) 
              reuslt = reuslt+((reuslt.length>0?"，":"")+_.get(value.valueRange, ['startvalue', '#'], '')+'~'+_.get(value.valueRange, ['endvalue', '#']));
            } else if (value.valueIdref) {
              const idRef  = _.get(value.valueIdref, ['#'], '');
              value = (lang.fValues[idRef]??idRef);
  
              reuslt = reuslt+((reuslt.length>0?"，":"")+(value));
            } else {
              let _value = _.get(value.valueSimple, ['#'], '');
              if (_value==='true'||_value==='false')
                _value = t(_value);
              reuslt = reuslt+((reuslt.length>0?"，":"")+_value);
            }
          }
          return reuslt;
        }
      }
      return '';
    };
  const formatFeatures =(productOptions, features, ftgroup, language, spuStatus) => {
    // console.log({productOptions}, {features}, {ftgroup}, {language}, {spuStatus});
    const keys = Object.keys(ftgroup);
    const groups = {};
    // 判断参数，spuStatus=true: SPU页面，判断spuShowAble;  spuStatus=false: SKU页面，判断showAble
    const getSPUSKUstatus = spuStatus ? 'spuShowAble' : 'showAble';
    groups['arrays_reserve'] = [];
    for (let i=0; i<features.length; i++) {
      const item = features[i];
      if (!item[getSPUSKUstatus])
        continue;
      let value = '';
      if (typeof(item.fvalue)==='object') {
        value = item.fvalue[lan];
      } else {
        value = (language.fValues[item?.fvalueIdref]??item.fvalue);
        if (value==='true')
          value = '有';
        else if (value==='false')
          value = '无';
      }
      if (productOptions?.length>0) {
        const values = getMultiValues(item.frIdref, productOptions, language);
        //多个值为空
        if (values.length!=0) {
          value = values;
        } else {
          // value += (item.unitCode??'')
        }
        // value = (getMultiValues(item.frIdref,productOptions).length==0?`${typeof(item.fvalue)==='object'?item.fvalue[lan]:((language.fValues[item?.fvalueIdref]??item.fvalue))} ${item.unitCode ?? ''}`:getMultiValues(item.frIdref,productOptions))
      } else {
        // value += (item.unitCode??'')
      }
      groups['arrays_reserve'].push({name:language.features[item.frIdref]??item.frIdref, value: value, unitCode:(item.unitCode??'')});
    }
    for (let i=0; i<keys.length; i++) {
      const items = ftgroup[keys[i]];
      // _.sortBy(items,function(e){return -e.ftOrder}) 
      if (!groups[keys[i]]) {
        groups[keys[i]] = [];
      }
      for (let m=0; m<items.length; m++) {
        const item = items[m];
        if (item[getSPUSKUstatus]) {
          let value = '';
          if (typeof(item.fvalue)==='object') {
            value = item.fvalue[lan];
          } else {
            value = (language.fValues[item?.fvalueIdref]??item.fvalue);
            if (value==='true')
              value = '有';
            else if (value==='false')
              value = '无';
          }
          if (spuStatus) {
            const values = getMultiValues(item.frIdref, productOptions, language);
            //多个值为空
            if (values.length!=0) {
              value = values;
            } else {
              // value += (item.unitCode??'')
            }
            // value = (getMultiValues(item.frIdref,productOptions).length==0?`${typeof(item.fvalue)==='object'?item.fvalue[lan]:((language.fValues[item?.fvalueIdref]??item.fvalue))} ${item.unitCode ?? ''}`:getMultiValues(item.frIdref,productOptions))
          } else {
            // value += (item.unitCode??'')
          }
          groups[keys[i]].push({name:language.features[item.frIdref]??item.frIdref, value, unitCode:(item.unitCode??'')});
        }
      }
    }
    return groups;
  };
  // 请求产品详情数据，并对数据进行排序
  const RequestDetail = () => {
    if (!tenant?.id) return;
    dispatch(getRobotProductsDetailAction({tenantId: tenant.id, id})).then((productDetail) => {
      let result = _.sortBy(productDetail?.richTextInfo, function(item) {
        return item.order; // 根据code对数据进行升序排序，若是降序则改成：return -item.code
      });
      let resultPro = _.sortBy(productDetail?.productArticle, function(item) {
        return item.orderIndex; // 根据code对数据进行升序排序，若是降序则改成：return -item.code
      });
      console.log('产品详情 === ', productDetail, result, resultPro)
      productDetail.richTextInfo = result 
      productDetail.productArticle = resultPro 
      setProductDetail(productDetail);
      const ftVals = formatFeatures(
        productDetail?.feature[0].productOptions,
        productDetail?.feature[0].features,
        productDetail?.feature[0].ftgroup,
        language_info[productDetail?.feature[0].referenceFeatureSystemName],
        productDetail?.spuStatus
      );
      console.log("ftVals============",ftVals)
      setFtTechnicals(ftVals);
    });
  };

  // 请求完整的树状数据
  const RequestAllCatalogs = () => {
    dispatch(getAllCatalogsAction({id: tenant.id})).then((allCatalogs) => {
      console.log('all catalogs = ', allCatalogs)
      const _allcats = filter(allCatalogs, (item) => {
        if (item.csIndex === '0') return false;
        return true;
      });
      setShowData(_allcats);
    });
  };

  useEffect(() => {
    if(deviceType === 'mobile') {
      viewer.showViewer({src: showImageUrl.url}, {viewerBg: '#00000069', onViewerHideListener: () => {
        setShowImageUrl({ show: false, url: '' });
      }}) 
    }
  }, [showImageUrl])

  useEffect(() => {
    if (!id) return;
    RequestDetail()
  }, [tenant?.id, id])

  useEffect(() => {
    if (!tenant) return;
    RequestAllCatalogs();
  }, [tenant?.id])

  useEffect(() => {
    if (!tenant) return;
    if (!showData || !productDetail) return;
    // 组装面包屑，先将树扁平化，这样方便通过 id 来查询
    var resultMap = {};
    hashMapTree(showData, resultMap);
    console.log('result map = ', resultMap)
    var breadcrumbs = [];
    getBreadcrumbsPath(resultMap, productDetail.id, breadcrumbs);
    breadcrumbs.reverse();
    console.log('breadcrumbs = ', breadcrumbs)
    setExtraBreadcrumbs(breadcrumbs);
  }, [showData, productDetail?.id])

  useEffect(() => {
    // let test = '';
    // Object.keys(_productState).map((key) => {  
    //     _productState[key]?.products?.map((item) => {
    //     if (item.id === productDetail?.id)
    //     test = key;
    //   });
    // });
    // const paths = [];
    // findPath(test, paths);   
    // if(deviceType==='mobile'){
    //   paths.push({to:'/'+params.catalogType+'/product?catalogType='+params.catalogType,name:'产品中心'})
    //   paths.push({to:'/'+params.catalogType,name:(getTitleById(params.catalogType)+(getTitleById(params.catalogType)==='伺服'?'系统':""))??''})
    //   // to={'/'+params.catalogType+'/product?catalogType='+params.catalogType}
    // }
    // paths.reverse(); 
    // paths.push({id:'', name:productDetail?.details?.descriptionShort?.zh, csname:''}); 
    // setExtraBreadcrumbs(paths);
    get3dUrls(productDetail);
    getDataSheet(productDetail)
  }, [productDetail?.id, deviceType]);

  const productImgs = getImageUrl(productDetail, [{'#text': '/images/dproduct.svg'}]);
  // console.log("productDetail============================", productDetail)

  return (
    <div style={{
      width: deviceType === 'desktop' ? '80%' : '100%', 
      height: '100%', 
      display:'flex', 
      flexDirection:'column', 
      // padding:'10px 0'
    }}>
      {/* 电脑端 面包屑 */}
      {deviceType === 'desktop' && <Breadcrumbs style={{height:'40px', padding:'10px 0'}} separator=">" maxItems={8}> 
        <Link color='textPrimary' to={'/'} component={RouteLink}>{t('menu.dashboard')}</Link>
        <Link color='textPrimary' to={'/products'} component={RouteLink}>{t('menu.products')}</Link>
        {extraBreadcrumbs.map((item, i) => {
          if (extraBreadcrumbs.length === i + 1) {
            return <Typography key={id}>{item.name}</Typography>;
          }
          return (
            <Link color='textPrimary' key={item.id} to={item.id ? '/products/' + item.id : null} component={RouteLink}>
              {item.name}
            </Link>
          )
        })}
      </Breadcrumbs>}

      {deviceType === 'mobile' && <div style={{display: showImageUrl.show ? 'block' : 'none', position:'absolute', left:'0px', right:'0px', top:'0px', bottom:'0px'}} id='pobi_mobile_viewer_single_image_id' />}
      {deviceType === 'desktop' && <Dialog maxWidth='lg' open={showImageUrl.show} style={{overflow:'auto'}} onClose={() => {
        viewer.hideViewer(); setShowImageUrl({...showImageUrl,show:false});
      }}>
        <DialogContent>
          <PhotoSlider visible={showImageUrl.show} maskOpacity={0.5} photoClassName={classes.mask} index={0}
            toolbarRender={({ rotate, onRotate, onScale, scale, index }) => {
              return (
                <>
                <svg
                  style={{marginRight:'10px'}}
                  className="PhotoView-PhotoSlider__toolbarIcon"
                  width="34"
                  height="34"
                  viewBox="0 0 768 768"
                  fill="white"
                  onClick={() => onScale(scale + 0.2)}
                >
                  <path d="M384 640.5q105 0 180.75-75.75t75.75-180.75-75.75-180.75-180.75-75.75-180.75 75.75-75.75 180.75 75.75 180.75 180.75 75.75zM384 64.5q132 0 225.75 93.75t93.75 225.75-93.75 225.75-225.75 93.75-225.75-93.75-93.75-225.75 93.75-225.75 225.75-93.75zM415.5 223.5v129h129v63h-129v129h-63v-129h-129v-63h129v-129h63z" />
                </svg>
                <svg
                  className="PhotoView-PhotoSlider__toolbarIcon"
                  width="34"
                  height="34"
                  viewBox="0 0 768 768"
                  fill="white"
                  onClick={() => onScale(scale - 0.2)}
                >
                  <path d="M384 640.5q105 0 180.75-75.75t75.75-180.75-75.75-180.75-180.75-75.75-180.75 75.75-75.75 180.75 75.75 180.75 180.75 75.75zM384 64.5q132 0 225.75 93.75t93.75 225.75-93.75 225.75-225.75 93.75-225.75-93.75-93.75-225.75 93.75-225.75 225.75-93.75zM223.5 352.5h321v63h-321v-63z" />
                </svg>
              </>)
            }}
            onClose={()=>{setShowImageUrl({...showImageUrl,show:false})}}
            onIndexChange={()=>{}}
            images={[showImageUrl.url].map((item: string) => ({ src: item, key: item }))}
          />
        </DialogContent>
      </Dialog>}

      <Box className={classes.pages} style={{ 
        width: '100%',
        height: deviceType === 'mobile' ? '100%' : 'calc(100% - 60px)',
        justifyContent:'center', 
        alignItems:'center'
      }}> 
        <Box style={{
          display: deviceType === 'mobile' ? "unset" : 'flex', 
          width: deviceType === 'mobile' ? 'calc(100% - 30px)' : '100%',
          borderRadius: deviceType === 'desktop' ? 'unset' : '15px',
          margin: deviceType === 'mobile' ? '15px' : '0px',
          justifyContent: 'center',
          height: '100%',
          background: 'white',
          flexDirection: deviceType === 'mobile' ? 'column' : 'row',
          overflow: deviceType === 'desktop' ? 'unset' : 'auto'
        }}>
          <Box style={{flexGrow:'1', width:deviceType === 'mobile' ? '100%' : '0px', display:'flex', flexDirection:'column'}}>
            <Box style={{display:'flex', flexDirection:'row'}}>
              <Typography style={{
                fontSize:'25px', 
                padding: deviceType === 'desktop' ? '30px' : '16px', 
                flexGrow:1
              }}>
                {productDetail?.details?.descriptionShort?.zh} 
              </Typography>
              {deviceType === 'mobile' && (!isEmpty(user)||window.WeixinJSBridge) && <Box style={{display:'flex',flexDirection:'row', alignItems:'center', padding:'16px'}}>
                <img src='/images/shareb.svg' style={{width:'20px', height:'20px', marginRight:'16px'}} onClick={()=>handleShare(productDetail)}></img>
                <img src='/images/heart.svg' style={{width:'20px',height:'20px'}} onClick={()=>handleFav(productDetail)}></img>
              </Box>}
            </Box>

            <Box style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column', paddingBottom:'20px'}}>
              {d3dImages.length > 0 && <D3DImageView images={d3dImages} />}
              {d3dImages.length > 0 && <img src='https://lite-cdn.yangbentong.com/d6ca9783-c5f9-4dd8-9ca1-b92a95d62e59/6b892de0-b327-4b2d-96fb-88dd607c142a.png' style={{width:'20px',height:'20px',marginTop:'-20px'}}/>}
              {d3dImages.length === 0 && <img src={productImgs[0]['#text']} style={{objectFit:'contain', width:'100%', height: '100%', maxHeight: '50vh' }}></img>}
              
              {/* 两个按钮 */}
              {deviceType === 'desktop' && (!isEmpty(user)||window.top!=window.self) && <Box style={{display:'flex', justifyContent:'center', alignItems:'center', marginTop:'20px'}}> 
                <Button startIcon={<Share /> } variant='contained' color='primary' size="small"
                  style={{
                    width:'124px', height:'40px', background:'black', marginRight: '20px', 
                    paddingTop:'4px', paddingBottom:'4px', paddingLeft:'20px', paddingRight:'20px'
                  }}
                  onClick={()=>handleShare(productDetail)}
                >
                  分享
                </Button>
                <Button startIcon={<FolderSpecial /> } variant='contained' color='primary' size="small"
                  style={{
                    width:'124px', height:'40px', background:'black', marginRight: '10px',
                    paddingTop:'4px',paddingBottom:'4px', paddingLeft:'20px', paddingRight:'20px'
                  }}
                  onClick={()=>handleFav(productDetail)}
                >
                  收藏
                </Button>
              </Box>}
            </Box>
            {/* <RelevantBox dataSheets={dataSheets} /> */}
          </Box>
          {deviceType === 'desktop' && <Divider orientation="vertical" variant="middle" style={{ margin: 0 }} />}
          <Box style={{flexGrow:'1', width:deviceType === 'desktop' ? '0px' : '100%', height:'100%'}}>
            {/* {productDetail?.productArticle?.length === 3 && <RichBox richTextInfo={productDetail?.richTextInfo} setShowImageUrl={setShowImageUrl} />} */}
            {productDetail?.productArticle?.length > 0 && <RichTextBox productArticle={productDetail?.productArticle } ftTechnicals={ftTechnicals} productDetail={productDetail} language={language_info} setShowImageUrl={setShowImageUrl} />}
          </Box>
        </Box> 
      </Box>
    </div>
  );
};

const CustomTabs = withStyles((theme: Theme) => ({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    bottom:'unset',
    bottom:'0px',
    height:'4px',
    '& > span': {
      width: '100%',
      backgroundColor: 'red',
    },
  },
  flexContainer:{
    alignItems:'center',
  },
  scrollButtons:{
    width:'unset'
  }
}))((props) => {
  return (
    <Tabs 
      variant="scrollable"
      scrollButtons='auto'
      aria-label="scrollable force tabs example"
      {...props}
      TabIndicatorProps={{ children: <span /> }} 
    />
  )
});

const RelevantTabs = withStyles((theme: Theme) => ({
  root:{
    minHeight: 'unset'
  },
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    bottom: 'unset',
    top: '0px',
    height: '4px',
    '& > span': {
      width: '100%',
      backgroundColor: 'white',
      display: 'none'
    },
  },
  flexContainer:{
    alignItems: 'flex-end',
    padding: '7px'
  }
}))((props) => {
  return (
    <Tabs
      variant="scrollable"
      scrollButtons='auto'
      // allowScrollButtonsMobile
      aria-label="scrollable force tabs example"
      {...props}
      TabIndicatorProps={{ children: <span /> }}
    />
  )
});

const CustomTab = withStyles((theme: Theme) => createStyles({
  root:{
    minWidth:'unset',
    minHeight:'unset',
  }
}))(Tab);


const RichBox = (props)=> {
  const [value, setValue] = useState(0);
  const deviceType = useContext(DeviceType);

  return (
    <Box style={{display:'flex', flexDirection:'column', height:'100%'}}>
      <CustomTabs 
        value={value} 
        onChange={(event, newValue) => { setValue(newValue); }} 
        aria-label="basic-tabs-example"
      >
        {props.richTextInfo?.map((item, i) => {
          return (<CustomTab key={i} label={item.name} style={{ color:value == i ? 'red' : 'black', fontSize:'17px'}} id={`simple-tabpanel-${i}`}/>)
        })}
      </CustomTabs>
      <Box style={{width:'100%', display:'flex', padding:'20px', height:'0px', flexGrow:1}}>
        {props.richTextInfo?.map((item, i) => {
          return (
            <TabPanel value={value}  id={i} >
              <Box>
                <RichText data={item.info} onClick={(block) => { props.setShowImageUrl({show: true, url: block.src})}} />
              </Box>
            </TabPanel>
          )
        })}
      </Box>
    </Box>
  )
}
// 技术参数详情
const FeatureItem = (props) => {
  const classes = useStyles();
  const { idx, index, item } = props;
  const innerText = useRef();
  const [showMult, setShowMulti] = useState(false);
  const [all, setAll] = useState(false);
  useLayoutEffect(() => {
    if (innerText.current.scrollHeight > innerText.current.clientHeight) {
      setShowMulti(true);
    }
  });
  return <div 
    key={idx + '' + index}
    className={classes.fi_public}
    style={{
      borderTop: index == 0 ? '1px solid rgb(215, 215, 215)' : 'unset',
      backgroundColor: index % 2 === 0 ? '' : 'rgba(249, 249, 249)',
      borderRight: showMult ? 'unset' : '1px solid rgb(215, 215, 215)',
    }}>
    <div
      className={classes.featContent1}
      style={{ backgroundColor: index % 2 === 0 ? '' : 'rgba(249, 249, 249)' }}
    >
      {`${item.name}${item?.unitCode ? ('(' + item?.unitCode + ')') : ''}:`}
    </div>
    <Box style={{ width: '70%', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <div ref={innerText} id='innerText'
        className={all ? classes.featContent : classes.featContent2}
        style={{ lineHeight: '24px', width: '100%' }}
      >
        {item.value}
      </div>
      {showMult && <Box 
        onClick={() => {
          setAll(!all);
        }} 
        className={classes.mult}
      >
        {all && <img style={{ height: '16px', width: '16px' }} src='/images/sup.svg'></img>}
        {(!all) && <img style={{ height: '16px', width: '16px' }} src='/images/sdown.svg'></img>}
      </Box>}
    </Box>
  </div>;
};
const TechnicalView = (props) => {
  const { ftgroup, language } = props;
  const classes = useStyles();
  const getVisibleCount = (items) => {
    let count = 0;
    for (let i = 0; i < items.length; i++) {
      count++;
    }
    return count;
  };
  return (
    
    <Box className={classes.tv_box}>
      {
        !_.isEmpty(ftgroup) && Object.keys(ftgroup).map((i, idx) => {
          const items = ftgroup[i];
          return (<Box key={idx} className={classes.mt10}>
            {/* 分组表头，key = arrays_reserve的默认不显示表头 */}
            {
              (i != 'arrays_reserve') && (getVisibleCount(items) > 0) && <div className='table_header'>
                {i}
              </div>
            }
            {items.map((item, index) => {
              return <FeatureItem
                key={`tab2itrem_${idx}_${index}`}
                item={item}
                language={language}
                idx={idx} index={index}
              />;
            })}
          </Box>);
        })
      }
    </Box>
  );
};
// 产品详情Tab内容
const RichTextBox = (props: any) => {
  const deviceType = useContext(DeviceType);
  // console.log("richTextInfo==", props.productArticle)
  const [value, setValue] = useState(0);
  const [articles, setArticels] = useState([]);
  
  useEffect(() => {
    setArticels(props.productArticle?.filter((item, i) => {
      return !item.disable;
    }));    document.addEventListener('click', (e) => {
      if(e.target.id === 'fulltext_content_img') {
        props.setShowImageUrl({show: true, url: e.target.currentSrc})
      } 
    })
  },[props.productArticle])
  return (
    <Box style={{display:'flex', flexDirection:'column', height:'100%'}}>
      <CustomTabs value={value} onChange={(event, newValue) => { setValue(newValue); }} aria-label="basic tabs example">
        {articles?.map((item, i) => {
          if (item.disable) return;
          return (<CustomTab label={Utills.getValueByLanguage(null,item.title)} key={i} style={{ color:value === i ? 'red' : 'black', fontSize:'17px'}} id={`simple-tabpanel-${0}`}/>)
        })}
      </CustomTabs>
      <Box style={{width:'100%', display:'flex', padding:'20px', height: deviceType === 'mobile' ? 'unset' : '100%', flexGrow: 1, overflowY:'scroll'}}>
        {articles?.map((item, i) => {
          // 技术参数
          if (item.index === 0) {
            return (
              <TabPanel value={Utills.getValueByLanguage(null,value)} key={i} id={i}>
               <TechnicalView 
                  ftgroup={props.ftTechnicals} 
                  features={props.productDetail?.feature[0].features} 
                  language={props.language[props.productDetail?.feature[0].referenceFeatureSystemName]}
                />
            </TabPanel>

            );
          }          
          let fulletxt = Utills.getValueByLanguage(null, item?.text)?.replace(/<img/g, '<img id="fulltext_content_img" ')
          fulletxt =Utills.getValueByLanguage(null,item?.text)?.replace(/<table/g, '<table style="width: 100%; height: auto" ')
          return (
            <TabPanel value={value} key={i} id={i}>
              <div id='fullText' dangerouslySetInnerHTML={{__html:fulletxt ?? ''}}></div> 
            </TabPanel>
          )})}
      </Box>
    </Box>
  );
}

const RelavantView = ({items})=>{
  const history = useHistory();
  return (
    <Box style={{display:'flex',flexDirection:'column'}}>
      {items.data.map((item) => {
        if (item.type === 'dataSheet') {
          const fileType = getFileType(item.url);
          const icon = fileType === 'photo' ? item.url : `/fileTypes/${fileType}.svg`;
          item.thunbnail = icon
        } else {
          item.thunbnail = item.url
        }
        return (
          <Box style={{display:'flex',padding:'8px',borderBottom:'1px solid #e3e3e3'}} onClick={() => {
            if (item.type === 'dataSheet') {
              window.open(item.to)
            } else {
              history.push(item.to)
            }
          }}>
            <img src={item.thunbnail} style={{ width:'20px', height:'20px'}}/>
            <Box style={{paddingLeft:'5px',cursor:'pointer'}}>{item.name}</Box>
          </Box>
        )
      })}
    </Box>
  )
}

const RelevantBox = (props: any) => {
  const deviceType = useContext(DeviceType);
  // console.log("dataSheets==", props.dataSheets)
  const [value, setValue] = useState(0);
  const [{index, select}, setSelect] = useState({index: 0, select: false})

  const close = () => {
    setSelect({index: 0, select: false})
  }

  if (deviceType === 'mobile') {
    return (
      <Box>
        {select && props.dataSheets[index] && <Dialog maxWidth="xs" fullWidth 
          open={select}
          onClose={() => { close() }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {props.dataSheets[index].name}
          </DialogTitle>
          <DialogContent>
            <Box>
              <RelavantView items={props.dataSheets[index]} />
              {/* <RichText data={item.info} /> */}
            </Box>
          </DialogContent>
        </Dialog>}
          
        <Box style={{display:'flex',flexDirection:'row',paddingTop:'5px',paddingBottom:'25px'}}>
          {props.dataSheets?.map((item,i)=>{
            return (
              <Box style={{paddingLeft:'10px', paddingRight:'5px', cursor:'pointer', display:'flex', flexDirection:'row', alignItems:'center'}} onClick={() => { 
                setSelect({index:i,select:true}) 
              }}>
                <Box style={{fontSize:'16px'}}>{item.name}</Box>
                <img src="/images/rightb.svg" style={{width:'11px', height:'11px'}}></img >
              </Box>
            )
          })}
        </Box>
      </Box>
    )
  }

  return (
    <Box style={{display:'flex', flexDirection:'column', flexGrow:'1', height:'0px'}}>
      <RelevantTabs value={value} onChange={(event, newValue) => { setValue(newValue); }} aria-label="basic tabs example">
        {props.dataSheets?.map((item, i) => {
          return (
            <CustomTab id={`simple-tabpanel-${0}`} label={item.name} style={{ 
              padding:'0px 12px', fontSize:'15px',
              color:value === i ? 'red' : 'black',
              borderLeft:value !== i ? 'unset' : '1px solid #e3e3e3',
              borderTop:value !== i ? 'unset' : '1px solid #e3e3e3',
              borderRight:value !== i ? 'unset' : '1px solid #e3e3e3',
              borderBottom:value === i ? 'unset' : '1px solid #e3e3e3'
            }}/>
          )
        })}
        {props.dataSheets?.length > 0 && <Box style={{width:'100%', borderBottom:'1px solid #e3e3e3'}} id={`simple-tabpanel-${0}`}/>}
      </RelevantTabs>

      <Box className='relatives'>
        {props.dataSheets?.map((item,i) => {
          return (
            <TabPanel value={value} id={i} >
              <Box>
                <RelavantView items={item} />
                {/* <RichText data={item.info} /> */}
              </Box>
            </TabPanel>
          )
        })}
      </Box>
    </Box>
  )
}

export default function ProductDetailViewContainer ({lanuage}) {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const tenant = useContext(TenantContext);
  const user = useContext(UserContext);
  const innerUser = useContext(InnerUserContext);
  // 页面参数
  const { id, extra } = useParams<any>() ?? {id: null};
  const params = queryParse(location.search);
  console.log('已知页面信息111 === ', innerUser)

  const [[anchorEl, selectId], setAnchorEl] = useState([null, null]);
  const [favSuccess, setFavSuccess] = useState(false);
  const [[mode, selectedIds], setModeAndData] = useState(['normal', []]);
  const [selectInfo, setSelectInfo] = useState({show: false, item: null, target: null});

  const handleClose = () => {
    setModeAndData(['normal', []]);
  };

  const handleMenuClose = () => {
    setAnchorEl([null, null]);
  };

  const handleShare = (detail) => {
    handleMenuClose()
    if(window.WeixinJSBridge){
      wx.miniProgram.navigateTo({
        url: `/pages/documents/documentShare?id=${detail.type === 'catalog' ? detail.cgId : (detail.type === 'product' ? detail.details.supplierAltPid : detail.id)}`
      });
      return;
    }
    if(window.self!=self.top){
      window.parent.postMessage({type:'share',item:detail},'*');
      return;
    }
    if (id === null || id.length === 0) {
      setModeAndData(['share', [selectId]]);
    } else {
      setModeAndData(['share', [id]]);
    }
  };

  const handleFav = (detail) => {
    handleMenuClose()
    if(window.WeixinJSBridge){         
      wx.miniProgram.navigateTo({
        
        url: `/pages/favorites/addToFavorites?did=${detail.type === 'catalog' ? detail.cgId : (detail.type === 'product' ? detail.details.supplierAltPid : detail.id)}&type=product`,
      });
      return;
    }
    if(window.self!=self.top){
      window.parent.postMessage({type:'collection',item:detail},'*');
      return;
    }
    if(id === null || id.length === 0) {
      setModeAndData(['favor', [selectId]]);
    } else {
      setModeAndData(['favor', [id]]);
    }
  };

  const createShare = (settings) => {
    if (!settings?.acl) {
      settings.acl = {};
    }
    console.log('分享======', settings)
    // 分享 shareType
    settings.shareType = 'web';
    dispatch(createShareAction({user, tenant, share: {
      ...settings,
      tenantId: tenant.id,
      documents: selectedIds
    }})).then((share) => {
      // @todo 暂时只支持一个文件的统计， 因为 ui 现在还不支持多选
      dispatch(documentEventAction({ user, tenant, document: { id: selectedIds[0] }, type: 'share', shareType: 'showcase' }));
      window.open(`/shares/${share.id}`);
      setModeAndData(['normal', []]);
    });
  };

  const handleSlShare = (id) => {
    handleMenuClose();
    if (id !== null || id.length !== 0) {
      setModeAndData(['share', [id]]);
    }
  };

  const handleSlFav = (id) => {
    handleMenuClose();
    if (id !== null || id.length !== 0) {
      setModeAndData(['favor', [id]]);
    }
  };

  useEffect(() => {
    if(id)
      dispatch(userShareEvent({user:{user:{id:innerUser?.userId??user?.user?.id}}, share:{tenantId:tenant.id,id:'11111111-1111-1111-1111-111111111111',memberId:innerUser?.memberId}, document:{id:id,type:'product'}, type:'view', detail:null}));
    window.addEventListener('message', function(e) {
      if (e.data.type === 'collection' && e.data.item) {
        setAnchorEl([null, e.data.item.type === 'catalog' ? e.data.item.cgId : e.data.item.details.supplierAltPid]);
        handleSlFav(e.data.item.type === 'catalog' ? e.data.item.cgId : e.data.item.details.supplierAltPid);
      } else if(e.data.type === 'share' && e.data.item) {
        setAnchorEl([null, e.data.item.type === 'catalog' ? e.data.item.cgId : e.data.item.details.supplierAltPid]);
        handleSlShare(e.data.item.type==='catalog' ? e.data.item.cgId : e.data.item.details.supplierAltPid);
      }
    });
  },[id])

  useEffect(() => {
    if (selectInfo.target === null) return;
    setAnchorEl([
      selectInfo.target, 
      selectInfo.item.type === 'catalog' ? selectInfo.item.cgId : selectInfo.item.details.supplierAltPid]);
  }, [selectInfo]);

  // console.log('0000 === ', tenant)
  return (
    <Paper style={{ 
      flex: 1, 
      width: '100%',
      height: '100%',
      display:'flex', 
      justifyContent:'center', 
      alignItems:'center', 
      background:'#f5f4f5'
    }} 
      elevation={0} 
    >
      <ProductDetailView id={id} handleShare={handleShare} handleFav={handleFav} language_info={lanuage}/>

      <Dialog open={mode === 'favor'} maxWidth="sm" fullWidth onClose={handleClose}>
        <FavorDialog selectedIds={selectedIds} onClose={handleClose} setFavSuccess={setFavSuccess}/>
      </Dialog>

      <Dialog maxWidth="sm" fullWidth open={favSuccess} onClose={() => { setFavSuccess(false); }} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          {t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040209')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            { t('common.collectionNotify')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='primary' size="medium" onClick={() => { setFavSuccess(false); }} autoFocus>
            { t('common.confirm')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={mode === 'share'} maxWidth="sm" fullWidth onClose={handleClose}>
        <ShareForm downloadable={false} onSubmit={createShare}  documents={{[selectedIds[0]]:selectInfo}} selectedId={selectedIds}/>
      </Dialog>
    </Paper>
  );
}